

















































// Vue
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { mapGetters } from 'vuex';
// Components
import NumberPicker, {
  NumberPickerColor,
} from '@/shared/components/number-picker.component.vue';
import Icon, { IconEnum } from '@/shared/components/icon.component.vue';
// Models
import {
  TypeOfPrice,
  TypeOfPriceLiteral,
  TypeOfProduct,
} from '@/manager/product/models/product.model';
import { PurchaseLine } from '@/clickbuy/purchase/models/purchase-line.model';
// Enums
import { LineColor } from '@/clickbuy/purchase/views/shopping-cart/shopping-cart-line/index.vue';
// Filters
import formatDate from '@/shared/filters/formatDate.filter.ts';

export enum ProductCardColor {
  Primary = 'product-card--primary',
  Secondary = 'product-card--secondary',
  Gold = 'product-card--gold',
}

@Component({
  components: {
    Icon,
    NumberPicker,
  },
  computed: {
    ...mapGetters({
      getProduct: 'getProduct',
      typeOfPrice: 'getTypeOfPrice',
      currentPurchase: 'getCurrentPurchase',
      acquiredCourses: 'acquiredCoursesList',
      convocationBalance: 'getConvocationBalance',
      hasPreviousPurchaseNotCanceled: 'hasPreviousPurchaseNotCanceled',
      loading: 'getCurrentPurchaseLoading',
    }),
  },
  filters: {
    formatDate,
  },
})
export default class ProductCard extends Vue {
  @Prop() private productId!: string;
  @Prop({ default: false }) private disabled!: boolean;
  @Prop({ default: ProductCardColor.Primary })
  private cardColor!: ProductCardColor;

  private getProduct!: any;
  private typeOfPrice!: TypeOfPrice;
  private currentPurchase!: any;
  private acquiredCourses!: any;
  private convocationBalance!: number;
  private loading!: number;
  private iconEnum = IconEnum;
  private amount = 0;

  @Watch('amount')
  private watchAmount(newVal: number, oldVal: number) {
    this.updateCurrentPurchase(newVal);
    this.watchCurrentPurchasePurchaseLine(newVal, oldVal)
  }

  @Watch('typeOfPrice')
  private watchTypeOfPrice() {
    this.updateCurrentPurchase(this.amount);
    if(this.currentPurchase.modifyPurchase || !this.currentPurchase.publicId){ 
      this.setSoonPayment()
    }
  }

  @Watch('hasRepeaterLines')
  private watchHasRepeaterLines(newVal: number, oldVal: number) {
    this.$store.dispatch('updateCurrentPurchase', this.currentPurchase);
  }

  get product() {
    return this.getProduct(this.productId);
  }

  get productIsCourse() {
    return this.product.typeOfProduct === TypeOfProduct.Course;
  }

  get productIsMerchandising() {
    return this.product.typeOfProduct === TypeOfProduct.Merchandising;
  }

  get productIsBook() {
    return this.product.typeOfProduct === TypeOfProduct.Book;
  }

  get convocationCourse() {
    let convInfo;
    if (this.acquiredCourses.products) {
      convInfo = this.acquiredCourses.products.find((product: any) => {
        return product.id === this.productId;
      });
    }

    return convInfo;
  }

  get isRepeater() {
    let repeater = false;
    if (this.convocationCourse) {
      const participants = this.convocationCourse.participants.filter(
        (participant: any) => {
          return participant.checked === true;
        },
      );
      repeater = participants.length > 0;
    }
    return repeater;
  }

  get convocationInfo() {
    let text = '| No cursado';
    if (this.isRepeater) {
      const participants = this.convocationCourse.participants.filter(
        (participant: any) => {
          return participant.checked === true;
        },
      );
      const index = participants.length - 1;
      const date = participants[index].date;
      text =
        '| ' + (this.$options as any).filters.formatDate(date, 'DD MMM · YYYY');
    }
    return text;
  }

  get title() {
    let title = 'Sin título';
    if (
      this.product &&
      this.product.level &&
      this.productIsCourse &&
      this.product.formativeBranch
    ) {
      title = `Nivel ${this.product.level}`;
    } else if (
      this.product &&
      this.productIsCourse &&
      this.product.acronym &&
      this.product.acronym.includes('TLP')
    ) {
      title = 'TLP';
    } else if (
      this.product &&
      this.productIsCourse &&
      !this.product.formativeBranch
    ) {
      title = 'Especialización';
    } else if (this.product && this.productIsBook) {
      title = 'Libro';
    } else if (this.product && this.productIsMerchandising) {
      title = 'Merchandising';
    }
    return title;
  }

  get subtitle() {
    let subtitle = 'Sin subtítulo';
    if (this.product) {
      subtitle = this.product.name;
    }
    return subtitle;
  }

  get pickerColor() {
    let pickerColor = NumberPickerColor.Primary;
    if (this.cardColor === ProductCardColor.Primary) {
      pickerColor = NumberPickerColor.Primary;
    } else if (this.cardColor === ProductCardColor.Secondary) {
      pickerColor = NumberPickerColor.Secondary;
    } else if (this.cardColor === ProductCardColor.Gold) {
      pickerColor = NumberPickerColor.Gold;
    }
    if (this.convocationCourse) {
      pickerColor = NumberPickerColor.Secondary;
    }
    return pickerColor;
  }

  get lineColor() {
    let lineColor = LineColor.Primary;
    if (this.cardColor === ProductCardColor.Primary) {
      lineColor = LineColor.Primary;
    } else if (this.cardColor === ProductCardColor.Secondary) {
      lineColor = LineColor.Secondary;
    } else if (this.cardColor === ProductCardColor.Gold) {
      lineColor = LineColor.Gold;
    }
    return lineColor;
  }

  get isActive() {
    return this.amountProductLine > 0 || this.hasRepeaterLines;
  }

  get amountProductLine() {
    let amount = 0;
    const line = this.currentPurchase.purchaseLines.find(
      (line: any) =>
        line.product.id === this.product.id && line.repeater === false,
    );
    if (line) {
      amount = line.amount;
    } else {
      this.amount = amount;
    }
    return amount;
  }

  get hasRepeaterLines() {
    return this.currentPurchase.purchaseLines.filter(
      (line: any) =>
        line.product.id === this.productId && line.repeater === true,
    ).length;
  }

  get repeaterProductAmount() {
    let amount = 0;
    const line = this.currentPurchase.purchaseLines.find(
      (line: any) =>
        line.product.id === this.productId && line.repeater === true,
    );
    if (line) {
      amount = line.amount;
    }
    return amount;
  }

  private getRepeaterPurchaseLineObject(
    line: PurchaseLine = new PurchaseLine(),
  ) {
    line.product = this.product;
    const coursePrice = this.product.repeat;
    line.totalPriceWithoutTax = coursePrice * line.amount;
    line.totalPriceTax = 0;
    line.totalPrice = line.totalPriceWithoutTax;
    line.color = LineColor.Secondary;
    line.repeater = true;

    return line;
  }

  private addRepeaterPurchaseLine() {
    if (!this.disabled && !this.loading) {
      const purchaseLines = this.currentPurchase.purchaseLines;
      const line = purchaseLines.find(
        (line: any) =>
          line.product.id === this.product.id && line.repeater === true,
      );
      if (line && line.amount > 0) {
        line.amount++;
        this.getRepeaterPurchaseLineObject(line);
      } else if (line === undefined) {
        this.currentPurchase.purchaseLines.push(
          this.getRepeaterPurchaseLineObject(),
        );
      }
      this.$store.dispatch('updateCurrentPurchase', this.currentPurchase);
    }
  }

  private getPurchaseLineObject(line: PurchaseLine = new PurchaseLine()) {
    line.product = this.product;
    line.amount = this.amount;
    const tax = (line.product as any).tax;
    const reserveAmount = this.product.reserve;
    const productPriceTag = TypeOfPriceLiteral[this.typeOfPrice];
    const price = this.product[productPriceTag];
    const paymentPendingWithoutTax = (price - reserveAmount) * line.amount;
    line.reserve = reserveAmount;
    if (reserveAmount === 0) {
      line.paymentPending = 0;
    } else {
      line.paymentPending =
        parseFloat((paymentPendingWithoutTax + paymentPendingWithoutTax * (tax / 100)).toFixed(2));
    }

    line.totalPriceWithoutTax = reserveAmount || price * line.amount;
    line.totalPriceTax = (tax * (line as any).totalPriceWithoutTax) / 100;
    line.totalPrice = (line as any).totalPriceWithoutTax + line.totalPriceTax;

    line.color = this.lineColor;
    return line;
  }

  private updateCurrentPurchase(amount: number) {
    const purchaseLines = this.currentPurchase.purchaseLines;
    const line = purchaseLines.find(
      (line: any) =>
        line.product.id === this.product.id && line.repeater === false,
    );
    if (line && amount > 0) {
      this.getPurchaseLineObject(line);
    } else if (amount === 0) {
      const index = purchaseLines.indexOf(line);
      if (index !== -1) {
        purchaseLines.splice(index, 1);
      }
    } else if (line === undefined) {
      this.currentPurchase.purchaseLines.push(this.getPurchaseLineObject());
    }
    let product = Object.assign({}, this.currentPurchase);
    this.$store.dispatch("updateCurrentPurchase", product);

  }

  private watchCurrentPurchasePurchaseLine(newVal: any, oldVal: any) {
    if(this.currentPurchase.modifyPurchase || !this.currentPurchase.publicId){ 
      this.setSoonPayment()
    }
  }

  private setSoonPayment(){
    if (this.currentPurchase.soonPaymentPurchaseCheck) {
      if(!this.currentPurchase.modifyPurchase){
        this.currentPurchase.reserveAmount = this.currentPurchase.soonPaymentPurchaseCheck ? this.currentPurchase.totalPriceWithoutTax : 0
      } else if(!this.currentPurchase.reserveAmount){
        this.currentPurchase.reserveAmount = this.currentPurchase.totalPaymentPending
      }
      if (this.currentPurchase.reserveAmount) {
        this.currentPurchase.reserveAmountTouched = true;
        this.currentPurchase.reserveAmount = this.getPurchaseLinesTotalPrice()
        this.$store.dispatch("updateCurrentPurchase", this.currentPurchase);
        this.currentPurchase.reserveAmountTouched = false;
      } else {
        this.$store.dispatch("updateCurrentPurchase", this.currentPurchase);
      }
    } 
  }

  private getPurchaseLinesTotalPrice(){
    let total = 0;
    const typeOfPrice = TypeOfPriceLiteral[this.typeOfPrice];
    if (this.currentPurchase.purchaseLines.length > 0) {
      total = this.currentPurchase.purchaseLines.reduce(
        (total: number, line: any) => {
          if (line.product) {
            const taxForm = line.product.tax / 100;
            if (line.repeater) {
              const tax = line.product.repeat * line.amount * taxForm;
              return total + line.product.repeat * line.amount + tax;
            } else {
              const tax = line.product[typeOfPrice] * line.amount * taxForm;
              return total + line.product[typeOfPrice] * line.amount + tax;
            }
          } else {
            return total;
          }
        },
        0
      );
    }
    return total;
  }
}
